import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagVentaCobranzaAdministrativaFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagVentaCobranzaAdministrativa'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagVentaCobranzaAdministrativa'
          label='Cobranza modo administrativa'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagVentaCobranzaAdministrativaFormGroup)
